import {getFullPath} from "./mappers";
import {type UserGroup, type WithDescription} from "./types";

export function sortByDescription<T extends WithDescription>(collection: T[]) {
  return [...collection]?.sort((a, b) => a?.description?.localeCompare(b?.description));
}

export const sortUserGroups = (userGroups: UserGroup[]) =>
  [...userGroups]?.sort((a, b) =>
    !a.description ? Number.NEGATIVE_INFINITY : getFullPath(a).localeCompare(getFullPath(b))
  );
